import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;

class CommentService {
    send(data) {
        return axios.post(API_URL+'comment/send', data, { headers: authHeader() });
    }
    list(id) {
        return axios.get(API_URL+'comment/report/'+id, { headers: authHeader() });
    }
}

export default new CommentService();
